import { useEffect, useRef, useState } from 'react';
import Sections from '~/constants/giveaway/sections';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import styles from './video.module.scss';
import {
  OverlayImageWrapper,
  MountainPeakImg,
  OverlayImage,
  PlaybackButton,
  SectionTitle,
  VideoDescription,
  VideoPlayer,
  VideoWrapper
} from './Video.styles';
import { PlayArrowIcon } from '../Icons';

const Video = () => {
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const [player, setPlayer] = useState<YT.Player | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hideOverlay, setHideOverlay] = useState(false);

  useEffect(() => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];

    if (firstScriptTag?.parentNode) {
      firstScriptTag?.parentNode.insertBefore(tag, firstScriptTag);
    }

    window.onYouTubeIframeAPIReady = () => {
      if (videoContainerRef.current) {
        new window.YT.Player(videoContainerRef?.current, {
          videoId: 'hpVtCX79n94',
          playerVars: {
            autoplay: 0,
            controls: 0,
            rel: 0
          },
          events: {
            onReady: event => {
              setPlayer(event.target);
            },
            onStateChange: event => {
              setIsPlaying(event.data === window.YT.PlayerState.PLAYING);
              setHideOverlay(!(event.data === YT.PlayerState.ENDED));
            }
          }
        });
      }
    };
  }, []);

  const videoPlayPause = () =>
    isPlaying ? player?.pauseVideo() : player?.playVideo();

  return (
    <div className="bg-grey-1">
      <section
        className={`${styles.mountainRangeSection} relative w-full bg-white`}
      >
        <picture>
          <source
            srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/Blue_Mountain_Peak_Desktop.svg`}
            media="(min-width: 1024px)"
          />
          <source
            srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/Blue_Mountain_Peak_Tablet.svg`}
            media="(min-width: 768px)"
          />
          <source
            srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/Blue_Mountain_Peak_Mobile.svg`}
            media="(min-width: 0px)"
          />
          <MountainPeakImg
            src={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/Blue_Mountain_Peak_Mobile.svg`}
            alt="Blue Mountain Peak"
          />
        </picture>
      </section>

      <section className="relative px-24">
        <SectionTitle>
          jaxson riddle’s
          <br />
          carvana experience
        </SectionTitle>
        <VideoWrapper>
          <OverlayImageWrapper
            shouldHide={hideOverlay}
            onClick={videoPlayPause}
            data-analytics-id="Red Bull - Video overlay clicked"
          >
            <picture>
              <source
                srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/overlay.png?width=912&height=513`}
                media="(min-width: 1024px)"
              />
              <source
                srcSet={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/overlay.png?width=524&height=295`}
                media="(min-width: 0px)"
              />
              <OverlayImage
                src={`${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/video/overlay.png?width=524&height=295`}
                shouldHide={hideOverlay}
              />
            </picture>
          </OverlayImageWrapper>
          <VideoPlayer ref={videoContainerRef} />
          <PlaybackButton
            type="button"
            onClick={videoPlayPause}
            shouldHide={isPlaying}
            data-analytics-id="Redbull - Playback button clicked"
          >
            <PlayArrowIcon />
          </PlaybackButton>
        </VideoWrapper>
        <VideoDescription>
          Not everyone can send it like Jaxson Riddle does in big-mountain
          freeride, but everyone can have a smooth and seamless car shopping
          experience with Carvana. Check out Jaxson as he shows how epic, yet
          simple, it is to shop for cars 100% online with Carvana.
        </VideoDescription>
      </section>
    </div>
  );
};

export default withErrorBoundary(Video, undefined, undefined, Sections.Video);
